<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12" v-if="quantityAttribute.is_distance" :for="id">
            {{ unitLabel ? unitLabel : 'Distance' }}
        </label>
        <label class="attribute-label m-bottom-12" v-else-if="service.unit_label" :for="id">
            {{ service.unit_label }}
        </label>

        <label class="attribute-label m-bottom-12" v-else :for="id">
            {{ unitLabel ? unitLabel : 'Quantity' }}
        </label>
        <a href="javascript:;"
           data-toggle="popover" data-placement="bottom" data-html="true"
           :data-content="toolTipContent"
           v-if=" quantityAttribute && removeTags(quantityAttribute.attribute_description) !== ''">
            <i class="fa fa-info-circle fa-lg"></i>
        </a>

        <div class="input-group width-100" v-if="unitLabel">
            <input type="number" step="0.01" :name="name" class="form-control price-new-inputs" @change="updateQuantity" :id="id" v-model="numberValue">
            <span class="input-group-addon input-group-addon-new-design" v-if="unitAttribute.default_value" style="background-color: #F5F5F6 !important;">
                <b> {{ unitAttribute.default_value }} </b>
            </span>
        </div>
        <div class="width-100" v-else>
            <input type="number" step="0.01" :name="name" class="form-control price-new-inputs" @change="updateQuantity" :id="id" v-model="numberValue">
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import alert from "bootstrap/js/src/alert";

export default {
    name: "UnitAttribute",
    props: {
        unitAttribute: {
            type: Object,
            required: true
        },
        quantityAttribute: {
            type: Object,
            required: true
        },
        value: null,
        service: null,
        unitLabel: null
    },
    data() {
        return {
            numberValue: this.value
        }
    },
    computed: {
        /**
         * get unitAttribute input id
         * @returns {string}
         */
        id() {
            if (this.quantityAttribute && parseInt(this.service.clone)  ) {
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}_${this.service.clone}`;
            }
            if (this.quantityAttribute && this.quantityAttribute.attribute_id ){
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}`;
            }
        },
        /**
         * get unitAttribute input name
         * @returns {string}
         */
        name() {
            if ( this.quantityAttribute && parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}_${this.service.clone}`;
            }
            if (this.quantityAttribute && this.quantityAttribute ){
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}`;
                        }
        },
        toolTipContent(){
            if (this.quantityAttribute &&  this.quantityAttribute.attribute_description){
                let text = this.removeTags(this.quantityAttribute.attribute_description);
                let imagePath = this.service.quantity_image_large;
                let image = `<br><img class='img-responsive' src='${imagePath}'>`
                return `${text} ${image}`

            }

        }
    },
    methods: {
        setDefaultValue() {
            if(this.quantityAttribute && this.quantityAttribute.default_value){
                this.numberValue = +this.quantityAttribute.default_value;
            }
            if(this.quantityAttribute && this.quantityAttribute.is_distance && this.service.visits[0].tracking_details[0].visit_distance){
                this.numberValue = parseFloat(this.service.visits[0].tracking_details[0].visit_distance);
            }
            if (this.quantityAttribute && this.quantityAttribute.service_attribute_value){
                this.numberValue = this.quantityAttribute.service_attribute_value;
            }
        },
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            return div.textContent || div.innerText || '';
        },
        updateQuantity() {
        EventBus.$emit("updateServicePrice", {
                service: this.service,
                serviceQuantity: this.numberValue
            })
        }
    },
    watch: {
        numberValue(value) {
            this.$emit('input', +value);
            this.updateQuantity()
        }
    },
    mounted() {
        setTimeout(() => {
            this.setDefaultValue()
        }, 1000);

    }
}
</script>

<style scoped>

</style>